<div class="dm-page-content mb-25">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <app-back-button />
        <div class="page-header">
          <div class="left-area">
            <span class="title">Gestão Documental</span>
            <span class="sub-title">Adicione, visualize e emita os documentos no sistema</span>
          </div>
          <div class="indicator" *ngIf="docsCount">
            <div class="indicator">
              <div class="icon">
                <img src="icons/book-closed2.svg" alt="Country Icon" />
              </div>
              <div class="text-bg">
                <span>{{docsCount}} Documentos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-search-bar (formValueChange)="handleFormValueChange($event)" primaryBtnLabel="Novo Documento"
      (onPrimaryBtnClick)="openComprovativoSubsidioModal()" [showFilterBtn]="true"
      (onFilterBtnClick)="showFilterModal()"></app-search-bar>

    <div class="row">
      <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
        <app-table [pagination]="pagination" [columns]="columns" (pageChange)="onPageChange($event)"
          (actionSelected)="onActionSelected($event)"></app-table>
      </ng-container>
      <ng-template #emptyTemplate>
        <div class="no-data">
          <app-data-void titulo="Nenhum Documento encontrado"
            descricao="Clique em Novo Documento para criar um."></app-data-void>
        </div>
      </ng-template>
    </div>

    <p-toast></p-toast>
    <p-confirmdialog></p-confirmdialog>
  </div>
</div>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="formDoc" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />

      <!-- Se for data -->
      <p-datepicker *ngIf="filter.type === 'date'" appendTo="body" [showIcon]="true"
        [formControlName]="filter.controlName" dateFormat="dd/mm/yy" [placeholder]="filter.placeholder">
      </p-datepicker>
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>
